import { StoreState } from "..";

export const selectFavourites = (state: StoreState) =>
  state.favourites.favourites;



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/favourites/selectors.ts